import { ChangeDetectionStrategy, Component, Input, ElementRef, OnDestroy, OnInit } from '@angular/core';

import { filter, Observable, Subscription } from 'rxjs';

import { FinnairOrder } from '@fcom/dapi/api/models';
import { LoaderTheme } from '@fcom/ui-components/index';

import { ExpediaHotelsWidgetService } from '../../../../services';
import { ExpediaHotelsWidgetStatus } from '../../enums';

@Component({
  selector: 'fin-expedia-hotels-widget',
  templateUrl: './expedia-hotels-widget.component.html',
  styleUrl: './expedia-hotels-widget.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpediaHotelsWidgetComponent implements OnInit, OnDestroy {
  @Input({ required: true }) order$: Observable<FinnairOrder>;

  protected readonly LoaderTheme = LoaderTheme;
  protected readonly WidgetStatus = ExpediaHotelsWidgetStatus;
  readonly iframeState$: Observable<ExpediaHotelsWidgetStatus>;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private expediaHotelsWidgetService: ExpediaHotelsWidgetService,
    private elementRef: ElementRef
  ) {
    this.iframeState$ = this.expediaHotelsWidgetService.iframeState$;
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.order$
        .pipe(filter((order) => !!order))
        .subscribe((order) => this.expediaHotelsWidgetService.initWidget(order, this.elementRef))
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
